import {
  createStandaloneToast as chakraCreateStandaloneToast,
  type CreateStandAloneToastParam as ChakraCreateStandaloneToastParam,
  type CreateStandaloneToastReturn as ChakraCreateStandaloneToastReturn,
} from '@chakra-ui/react-v2';

import { defaultOptions } from './utils/constants';

export type CreateStandaloneToastParam = ChakraCreateStandaloneToastParam;

export type CreateStandaloneToastReturn = ChakraCreateStandaloneToastReturn;

export const createStandaloneToast = (
  param: CreateStandaloneToastParam,
): CreateStandaloneToastReturn =>
  chakraCreateStandaloneToast({
    ...param,
    defaultOptions: { ...defaultOptions, ...param?.defaultOptions },
  });
